import { Heading } from '~src/components/display';
import { useLocalization } from '~src/hooks';

import { InstallationGuideEntry } from './InstallationGuideEntry';
import { InstallationGuideImages } from './InstallationGuideImages';
import { InstallationGuideSectionProps } from './types';

import { informationColumn, installationGuideSectionHeader } from './installationGuide.module.css';

export const InstallationGuideOther = ({ answerMap, imageList }: InstallationGuideSectionProps) => {
  const translate = useLocalization();

  if (!answerMap?.otherNotes?.answer && !imageList?.length) {
    return null;
  }

  return (
    <div>
      <Heading className={installationGuideSectionHeader} level={2}>
        {translate.OTHER}
      </Heading>

      <div className={informationColumn}>
        {!!answerMap?.otherNotes?.answer && (
          <InstallationGuideEntry label={translate.NOTES} value={answerMap?.otherNotes?.answer} />
        )}

        {!!imageList?.length && <InstallationGuideImages imageList={imageList} />}
      </div>
    </div>
  );
};
